import axios from 'axios';
import config from '../config';

const TOKEN_KEY = 'checkin_token';

const api = axios.create({
  baseURL: config.apiUrl,
  timeout: 15000,
});

api.interceptors.request.use((req) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// ---------------------------------------------------------------------------
// Client auth
// ---------------------------------------------------------------------------

export async function loginWithToken(token) {
  const res = await api.post('/auth/checkin/login', { token });
  return res.data;
}

export async function devLogin(clientType = 'hff') {
  const res = await api.post(`/auth/checkin/dev-login?client_type=${clientType}`);
  return res.data;
}

// ---------------------------------------------------------------------------
// Wizard progress (client-facing)
// ---------------------------------------------------------------------------

export async function getProgress() {
  const res = await api.get('/wizard/progress');
  return res.data;
}

function getDeviceType() {
  const ua = navigator.userAgent || '';
  return /Mobi|Android|iPhone|iPad|iPod/i.test(ua) ? 'mobile' : 'desktop';
}

export async function saveProgress(currentStep, formData, completed = false) {
  const res = await api.put('/wizard/progress', {
    current_step: currentStep,
    form_data: formData,
    completed,
    device_type: getDeviceType(),
  });
  return res.data;
}

export async function getMe() {
  const res = await api.get('/wizard/me');
  return res.data;
}

// ---------------------------------------------------------------------------
// Admin (advisor-facing)
// ---------------------------------------------------------------------------

export async function createClient(clientData, advisorToken) {
  const res = await axios.post(`${config.apiUrl}/admin/checkin/clients`, clientData, {
    headers: { Authorization: `Bearer ${advisorToken}` },
  });
  return res.data;
}

export async function listClients(advisorToken) {
  const res = await axios.get(`${config.apiUrl}/admin/checkin/clients`, {
    headers: { Authorization: `Bearer ${advisorToken}` },
  });
  return res.data;
}

export default api;
